import { ApiService } from "../..";

export const loginWithPassword = (
  account: string,
  password: string,
  role: "admin" | "leader" | "member"
) => {
  return ApiService.baseAction(
    "auth/login/pwd",
    {
      data: {
        account,
        password,
        role,
      },
    },
    "post"
  );
};
